import { SET_LOGGED_IN, SET_PROFILE, SET_REPORT_DATA_BY_TOKEN } from '@actions/user'

import AuthUtil from '@util/AuthUtil'

const defaultState = {
  loggedIn: !!AuthUtil.getAccessToken(),
  username: '',
  profile: null,
  reportData: null
}

const userReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_LOGGED_IN: {
      const { loggedIn, username } = action
      return {
        ...state,
        loggedIn,
        username,
      }
    }
    case SET_PROFILE: {
      const { data } = action
      return {
        ...state,
        profile: data,
      }
    }
    case SET_REPORT_DATA_BY_TOKEN: {
      const { reportData } = action
      return {
        ...state,
        reportData,
      }
    }
    default:
      return state
  }
}

export default userReducer
